module.exports = __webpack_public_path__ + "img/otp.c9d102d9.jpg";